import * as types from '../actionTypes/index';
const initialState = {
  productCompareList : [],
  showError: '',
  productCompareAttrList: [],
}
const productCompareReducer = (state = initialState, action) =>{

  switch (action.type) {
    case types.ADD_COMPARE_PRODUCT:
        return {
          ...state,
          productCompareList: [...state.productCompareList, action.payload],
          showError: ''
        }
    case types.REMOVE_COMPARE_PRODUCT: {
        // eslint-disable-next-line no-case-declarations
        const sku =  action.payload.sku
        const updatedArray = state.productCompareList.filter(product => product.sku !== sku)
        return {
          ...state,
          productCompareList: updatedArray,
          showError: ''
        }
      }
    case types.REMOVE_ALL:
      return {
        ...state,
        productCompareList: [],
        showError: ''
      }
    case types.SHOW_COMPARE_ERROR:
        return {
          ...state,
          showError: action.payload
        }
    case types.PRODUCT_COMPARE_LIST:
        return {
          ...state,
          productCompareAttrList: action.payload,
        }
    case types.REPLACE_COMPARE_PRODUCT: {
        const previousItemSku =  action.payload.previousItem.sku;
        const updatedArray = [...state.productCompareList]
        updatedArray.map((prod, index) => {
          if(prod.sku === previousItemSku) {
            return updatedArray.splice(index, 1, action.payload.currentItem)
          }
        })
        return {
          ...state,
          productCompareList: updatedArray
        }
    }
    default:
        return state;
  }

};
export default productCompareReducer;
